import { render, staticRenderFns } from "./getStopElectric.vue?vue&type=template&id=89a60f78&scoped=true&"
import script from "./getStopElectric.vue?vue&type=script&lang=js&"
export * from "./getStopElectric.vue?vue&type=script&lang=js&"
import style0 from "./getStopElectric.vue?vue&type=style&index=0&id=89a60f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a60f78",
  null
  
)

export default component.exports